import { render, staticRenderFns } from "./HomepageTwitterNew.vue?vue&type=template&id=cbf30abc&"
import script from "./HomepageTwitterNew.vue?vue&type=script&lang=ts&"
export * from "./HomepageTwitterNew.vue?vue&type=script&lang=ts&"
import style0 from "./HomepageTwitterNew.vue?vue&type=style&index=0&id=cbf30abc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports